import _ from 'lodash';

export const buildDoneByOptions = (staff = [], historicalPerformers = []) => [
   { value: 'null', label: 'Not Done' },
   ..._.uniqBy([
      ...staff.map((member) => ({ noUser: member.noUser, name: member.user.name })),
      ...historicalPerformers
   ], 'noUser').map((member) => ({ value: member.noUser, label: member.name || 'Unknown user' }))
];
